import { BKJTableBody, BKJTableWrapper } from 'components/BKJTable/BKJTable.styled';
import { BKJTableRowWrapper } from 'components/BKJTable/BKJTableRow/BKJTableRow.styled';
import styled, { css } from 'styled-components';
import { BKJForm } from 'components/FormWrapper';
import { P } from 'components/Typography';
import { BKJButton } from '@bookjane2/bookjane-design-library';
import { BKJTableSubHeaderWrapper } from 'components/BKJTable/BKJTableSubHeader/BKJTableSubHeader.styled';

export const PositionsAllocationForm = styled(BKJForm)`
  max-height: 100%;
`;

export const PositionsAllocationNote = styled(P)`
  margin-bottom: 0;
`;

export const NoAssignedPositionsMessageTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: ${({ theme }) => theme.colors.PrimaryDefault};
`;

export const EmptyStateMessage = styled.div`
  font-size: 20px;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const NoAssignedPositionsMessage = styled.div`
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;

export const PositionsAllocationEditButton = styled(BKJButton)`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  min-height: 44px;
`;

export const PositionsAllocationSubHeaderWrapper = styled(BKJTableSubHeaderWrapper)<{
  readOnly?: boolean;
  center?: boolean;
}>`
  height: 76px;
  min-width: ${({ readOnly }) => (readOnly ? '844px' : '100%')};
  ${({ center }) =>
    center &&
    css`
      justify-content: center;
    `}
`;

export const PositionsAllocationSubHeaderTitle = styled.div<{
  textAlignCenter?: boolean;
  largeFont?: boolean;
}>`
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: ${({ largeFont }) => (largeFont ? '20px' : '16px')};
  font-weight: 600;
  line-height: 28px;
  margin: ${({ textAlignCenter }) => (textAlignCenter ? 'auto' : '0')};
  text-align: center;
`;

export const CheckboxText = styled.div`
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-family: 'Poppins Medium';
  padding-left: 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  min-width: 64px;
`;

export const PositionsAllocationSubHeaderTableData = styled.div<{ center?: boolean }>`
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};
  padding: 16px 24px;
  width: 100%;
  height: 72px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  background-color: inherit;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey4};
`;

export const PositionsAllocationTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-bottom: 40px;
`;

export const PositionsAllocationGroup = styled.div`
  width: 100%;
`;

export const PositionsAllocationTableBody = styled(BKJTableBody)`
  width: 100%;
`;

export const PositionsAllocationContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;
  width: 85%;
  flex-grow: 1;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  padding-bottom: 24px;
  @media (max-width: 1450px) {
    width: 100%;
  }
`;

export const PositionsAllocationTableWrapper = styled(BKJTableWrapper)`
  width: 100%;
  height: auto;
`;

export const PositionsAllocationTableRowWrapper = styled(BKJTableRowWrapper)<{ isGrey?: boolean }>`
  background-color: ${({ isGrey, theme }) => (isGrey ? theme.colors.Grey1 : 'white')};
`;

export const UnderlineButton = styled(BKJButton)`
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  text-decoration: underline;
  background-color: transparent;
  border: none;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  padding: 0px;
  justify-content: center;
`;

export const SupervisorText = styled.div`
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
`;

export const ChargeRateTableData = styled(PositionsAllocationSubHeaderTableData)`
  padding: 16px 12px;
`;

export const ChargeRateField = styled.div<{ hasError?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 28px;
  ${({ hasError, theme }) =>
    hasError &&
    css`
      && input {
        border-color: ${theme.colors.ErrorDefault};
      }
    `}
`;

export const ChargeRateWarningIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  line-height: 0;
`;

export const ChargeRateWarningTooltip = styled.div`
  width: max-content;
  word-wrap: break-word;
`;
